'use client';

import { usePathname, useSearchParams } from 'next/navigation';

export function useProductContext() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const productFromQuery = searchParams?.get('product');
  const defaultProduct = pathname?.includes('/us/heroes')
    ? 'ring-pro'
    : 'ring-air';

  console.log({ path: pathname });
  const product = productFromQuery ?? defaultProduct;
  const isRingPro = product === 'ring-pro';

  return {
    product,
    isRingPro,
    productName: isRingPro ? 'Ring Pro' : 'Ring AIR',
    buyLink: isRingPro ? '/ring-pro/buy' : '/ring/buy',
  };
}
